export default {
  namespaced: true,
  state: {
    user: {},
    role: '',
    allPermissions: {
      create: true,
      edit: true,
      delete: true,
      view: true,
      view_charts: true // New permission added here
    },
    noPermissions: {
      create: false,
      edit: false,
      delete: false,
      view: true,
      view_charts: false // New permission added here
    },
    permissions: []
  },
  getters: {
    getUser(state) {
      return state.user
    },
    getRole(state) {
      return state.role
    },
    getAllPermissions(state) {
      return state.permissions
    },

    getModelPermissions: state => model => {
      if (model && state.role === 'admin') {
        return state.allPermissions
      }
      if (model && state.role === 'salesRep') {
        return {
          create: state.permissions.includes(`CREATE_${model.toUpperCase()}`),
          edit: state.permissions.includes(`EDIT_${model.toUpperCase()}`),
          delete: state.permissions.includes(`DELETE_${model.toUpperCase()}`),
          view: state.permissions.includes(`VIEW_${model.toUpperCase()}`),
          view_charts: state.permissions.includes(`VIEW_CHARTS_${model.toUpperCase()}`)
        }
      }
      return state.noPermissions
    },
    getContractPermissions(state) {
      if (state.role === 'admin') {
        return state.allPermissions
      } else if (state.role === 'salesRep') {
        return {
          create: false,
          update: false,
          delete: false,
          view: true
        }
      } else {
        return state.noPermissions
      }
    },
    getTransactionPermissions(state) {
      if (state.role === 'admin') {
        return state.allPermissions
      } else if (state.role === 'salesRep') {
        return {
          create: false,
          update: false,
          delete: false,
          view: true
        }
      } else {
        return state.noPermissions
      }
    },
    getListingPermissions(state) {
      if (state.role === 'admin') {
        return state.allPermissions
      } else if (state.role === 'salesRep') {
        return {
          create: false,
          update: false,
          delete: false,
          view: true
        }
      } else {
        return state.noPermissions
      }
    }
  },
  actions: {
    setUser(context, payload) {
      context.commit('SET_USER', payload)
    },
    setRole(context, payload) {
      context.commit('SET_ROLE', payload)
    },
    setPermissions({ commit }, payload) {
      commit('SET_PERMISSIONS', payload)
    },
    setSinglePermission({ commit }, payload) {
      commit('SET_SINGLE_PERMISSION', payload)
    }
  },
  mutations: {
    SET_USER(state, payload) {
      state.user = payload
    },
    SET_ROLE(state, payload) {
      state.role = payload
    },
    SET_PERMISSIONS(state, payload) {
      state.permissions = payload
    },
    SET_SINGLE_PERMISSION(state, { name, value }) {
      state.permissions[name] = value
    }
  }
}
